<template>
  <b-modal
    id="modal-upload-files"
    :modal-class="[
      showDetails ? 'dialog-1200' : 'dialog-800',
    ]"
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
    @close="close"
    class="modal-upload-files"
  >
    <template #modal-title>
        <h3>Ciclo de facturación</h3>
    </template>
    <b-card v-show="!showDetails">
      <form-render
        ref="formRenderStatusCompany"
        :form.sync="formCountry"
        :fields="fieldsCountry"
        :key="keyFormRenderCountry"
      />
      <b-tabs justified class="tab-primary" v-model="tabIndex" @activate-tab="activatedEvent">
        <b-tab>
          <template #title>
            <div :class="[!allow.cost ? 'blocked-element' : '', 'tab-title']">
              <span>{{$t('Importar costos distribución')}}</span>
            </div>
          </template>
            <b-alert variant="warning" show v-if="avaliableReports.imports" class="mt-2 p-1">
              <div class="d-flex align-items-center">
                <feather-icon class="mr-50" icon="AlertTriangleIcon" size="30"/>
                <span> Hay reportes de importación en progreso. </span>
                <button class="btn btn-link" variant="link" @click="showDetailsOfInfo">
                  ver detalles
                </button>
              </div>
            </b-alert>
            <b-alert variant="success" show v-else class="mt-2 p-1">
                <feather-icon class="mr-50" icon="CheckIcon" size="30"/>
                <span> No hay reportes de importación pendientes. </span>
                <button class="btn btn-link" variant="link" @click="showDetailsOfInfo">
                  ver detalles
                </button>
            </b-alert>
          <div @click="e => handleClickOnComponent(e, allow.cost)" :class="!allow.cost ? 'blocked-element' : ''">
            <upload-cost-manage v-bind:disabled="true" @closeModal="closeModal" @blockTabs="blockTabs" :selectedCountry="formCountry.country"/>
          </div>
        </b-tab>
        <b-tab>
          <template #title>
            <div :class="[!allow.exportService ? 'blocked-element' : '', 'tab-title']">
              <span>{{$t('Exportar otros servicios')}}</span>
            </div>
          </template>
          <div @click="e => handleClickOnComponent(e, allow.exportService)" :class="!allow.exportService ? 'blocked-element' : ''">
            <b-alert variant="warning" show v-if="avaliableReports.export" class="mt-2 p-1">
              <div class="d-flex align-items-center">
                <feather-icon class="mr-50" icon="AlertTriangleIcon" size="30"/>
                <span> Hay reportes de exportación en progreso. </span>
                <button class="btn btn-link" variant="link" @click="() => showDetailsOfInfo(true)">
                  ver detalles
                </button>
              </div>
            </b-alert>
            <b-alert variant="success" show v-else class="mt-2 p-1">
                <feather-icon class="mr-50" icon="CheckIcon" size="30"/>
                <span> No hay reportes de exportación pendientes. </span>
                <button class="btn btn-link" variant="link" @click="() => showDetailsOfInfo(true)">
                  ver detalles
                </button>
            </b-alert>
            <export-service v-bind:disabled="true" @closeModal="closeModal" @blockTabs="blockTabs" :selectedCountry="formCountry.country"/>
          </div>
        </b-tab>
        <b-tab>
          <template #title>
            <div :class="[!allow.invoices ? 'blocked-element' : '', 'tab-title']">
            <span> {{$t('Detalles de facturación')}} </span>
            </div>
          </template>
          <div @click="e => handleClickOnComponent(e, allow.invoices)" :class="!allow.invoices ? 'blocked-element' : ''">
            <upload-invoices-manage @closeModal="closeModal" @blockTabs="blockTabs" :selectedCountry="formCountry.country"/>
          </div>
        </b-tab>
        <b-tab>
          <template #title>
            <div :class="[!allow.notifications ? 'blocked-element' : '', 'tab-title']">
            <span>{{$t('Notificaciones')}}</span>
            </div>
          </template>
          <div @click="e => handleClickOnComponent(e, allow.notifications)" :class="!allow.notifications ? 'blocked-element' : ''">
            <send-notification-manage @closeModal="closeModal" @blockTabs="blockTabs" :selectedCountry="formCountry.country"/>
          </div>
        </b-tab>
        <b-tab>
          <template #title>
            <div :class="[!allow.indemnifications ? 'blocked-element' : '', 'tab-title']">
            <span> {{$t('Indemnizaciones')}} </span>
            </div>
          </template>
          <div @click="e => handleClickOnComponent(e, allow.invoices)" :class="!allow.indemnifications ? 'blocked-element' : ''">
            <upload-indemnification-manage @closeModal="closeModal" @blockTabs="blockTabs" :selectedCountry="formCountry.country"/>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-card v-show="showDetails">
      <b-button variant="outline-primary mb-2" class="rounded-pill" @click="detailsGoBack">
        <feather-icon icon="ArrowLeft" /> Volver atras
      </b-button>
      <b-tabs justified class="tab-primary" v-model="tabIndexDetails" @activate-tab="activatedEvent">
        <b-tab>
          <template #title>
            <div :class="[!allow.cost ? 'blocked-element' : '', 'tab-title']">
              <span>{{$t('Detalles de importaciones')}}</span>
            </div>
          </template>
          <table-render v-if="!loading.statusCost" :schema="schema" :rows="rowsLogsImports" :actions="actionsLogs" :loading="loading.statusCost">
            <template #status="scope">
                <label :class="scope.rowdata.status == 1 ? 'text-success' : 'text-danger'">{{ scope.rowdata.status == 1 ? 'correcto' : 'error' }} <feather-icon v-if="scope.rowdata.status == 0" v-b-tooltip.hover.top="scope.rowdata.error_message" icon="InfoIcon" size="15" class="warning filterInput-XIcon"/> </label>
              </template>
              <template #reported="scope">
                <b-badge v-show="scope.rowdata.reported" variant="success">Reportado</b-badge>
                <b-badge v-show="!scope.rowdata.reported" variant="warning">Pendiente</b-badge>
              </template>
              <template #user_email="scope">
                <!-- Show two initial of name and last name and tooltip with email -->
                <span v-if="scope.rowdata.user_email" v-b-tooltip.hover.top="scope.rowdata.user_email" class="text-primary">
                  {{ scope.rowdata.user.name.split(" ").map(word => word.charAt(0)).join("") }}
                </span>
              </template>
          </table-render>
          <div v-if="loading.statusCost">
            <b-skeleton height="40px" width="`calc(100vh - 2.5rem)`" class="mt-1 mb-1" />
            <div class="table-skeleton-tableQuoter">
              <b-skeleton-table :rows="5" :columns="6" :table-props="{ }" />
            </div>
          </div>
        </b-tab>
        <b-tab>
          <template #title>
            <div :class="[!allow.exportService ? 'blocked-element' : '', 'tab-title']">
              <span>{{$t('Detalles de exportaciones')}}</span>
            </div>
          </template>
          <table-render :schema="schema" :rows="rowsLogsExports" :actions="actionsLogs" :loading="loading.statusCost" v-if="!loading.statusCost"> 
              <template #status="scope">
                <label :class="scope.rowdata.status == 1 ? 'text-success' : 'text-danger'">{{ scope.rowdata.status == 1 ? 'correcto' : 'error' }} <feather-icon v-if="scope.rowdata.status == 0" v-b-tooltip.hover.top="scope.rowdata.error_message" icon="InfoIcon" size="15" class="warning filterInput-XIcon"/> </label>
              </template>
              <template #reported="scope">
                <b-badge v-show="scope.rowdata.reported" variant="success">Reportado</b-badge>
                <b-badge v-show="!scope.rowdata.reported" variant="warning">Pendiente</b-badge>
              </template>
              <template #user_email="scope">
                <!-- Show two initial of name and last name and tooltip with email -->
                <span v-if="scope.rowdata.user_email" v-b-tooltip.hover.top="scope.rowdata.user_email" class="text-primary">
                  {{ scope.rowdata.user.name.split(" ").map(word => word.charAt(0)).join("") }}
                </span>
              </template>
          </table-render>
          <div v-if="loading.statusCost">
            <b-skeleton height="40px" width="`calc(100vh - 2.5rem)`" class="mt-1 mb-1" />
            <div class="table-skeleton-tableQuoter">
              <b-skeleton-table :rows="5" :columns="6" :table-props="{ }" />
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import uploadCostManage from './components/billing-cycle/uploadCost.vue'
import uploadInvoicesManage from './components/billing-cycle/uploadInvoices.vue'
import sendNotificationManage from './components/billing-cycle/SendNotification.vue'
import uploadIndemnificationManage from './components/billing-cycle/uploadIndemnification.vue'
import ExportService from './components/billing-cycle/exportServices.vue'

export default {
  name: 'modal-upload-files',
  components: { uploadCostManage, uploadInvoicesManage, sendNotificationManage, uploadIndemnificationManage, ExportService },

  data() {
    return {
      formCountry: {},
      fieldsCountry: [],
      keyFormRenderCountry: 0,
      tabIndex: 0,
      callingService: false,
      allow: {
        cost: true,
        invoices: true,
        notifications: true,
        indemnifications: true,
        exportService: true
      },
      avaliableReports: {
        export: false,
        imports: false
      },
      TAB_KEYS: ['cost', 'exportService', 'invoices', 'notifications', 'indemnifications'],
      allowedTabsByCountry: Object.freeze({
        CL: ['cost', 'invoices', 'exportService', 'notifications', 'indemnifications'],
        MX: ['cost', 'exportService'],
        CO: ['cost', 'invoices', 'exportService', 'notifications'],
        PE: ['cost', 'exportService'],
        AR: [],
        EC: [],
        US: [],
        BR: [],
        UY: []
      }),
      showDetails: false,
      rowsLogsImports: [],
      rowsLogsExports: [],
      loading: {
        statusCost: true
      },
      actionsLogs: [],
      schema: [],
      tabIndexDetails: 0
    }
  },
  computed: {
    ...mapGetters({
      countries: 'getCountries',
      statusCost: 'getStatusCost'
    })
  },
  watch: {
    countries () {
      this.setCountry()
    },
    statusCost() {
      this.avaliableReports.export = this.statusCost.meta.resultContainsPendingReportsOf.exports
      this.avaliableReports.imports = this.statusCost.meta.resultContainsPendingReportsOf.imports
      this.rowsLogsExports = this.statusCost.exportCostBatches.map(item => ({
        ...item,
        country_name: item.country.name,
        user_email: item.user.email,
        qtyrows: item.qtyRows,
        createdAt: this.$options.filters.moment(item.createdAt, 'DD/MM/YYYY HH:mm:ss'),
        updatedAt: this.$options.filters.moment(item.updatedAt, 'DD/MM/YYYY HH:mm:ss')
      }))

      this.rowsLogsImports = this.statusCost.importCostBatches.map(item => ({
        ...item,
        country_name: item.country.name,
        user_email: item.user.email,
        qtyrows: item.qtyRows,
        createdAt: this.$options.filters.moment(item.createdAt, 'DD/MM/YYYY HH:mm:ss'),
        updatedAt: this.$options.filters.moment(item.updatedAt, 'DD/MM/YYYY HH:mm:ss')
      }))
      this.loading.statusCost = false
    },
    showDetails(isExportDetails) {
      if (isExportDetails) {
        this.tabIndexDetails = 1
      } else {
        this.tabIndexDetails = 0
      }
    }
  },
  mounted () {
    this.setInitialData()
    this.initializeData()
  },
  methods: {
    setInitialData () {
      this.fieldsCountry = [
        {fieldType: 'FieldSelect', label: this.$t('País'), name: 'country', addFlags:true, useLabel: true, clearable:false, containerClass: 'col-md-4 container-info col-sm-6', change: this.checkAvailability}
      ]
      if (!!this.countries.length) this.setCountry()
    },
    initializeData() {
      this.schema = [
        { label: 'Codigo', key: 'code' },
        { label: 'Usuario', key: 'user_email', useSlot: true },
        { label: 'País', key: 'country_name' },
        { label: 'Reportado', key: 'reported', useSlot: true },
        {label: 'Cantidad de filas', key: 'qtyrows'},
        { label: 'Creación', key: 'createdAt' },
        { label: 'Actualización', key: 'updatedAt' }
      ]
    },
    setCountry() {
      // Filtrar países con opciones disponibles
      const validCountries = this.countries.filter(country =>
        this.allowedTabsByCountry[country.code]?.length > 0
      )
      // Actualizar opciones del selector
      this.setSelectOptions('country', { options: validCountries })
      // Si no hay país seleccionado o el país actual no es válido, establecer Chile como default
      if (!this.formCountry.country || !validCountries.find(c => c.code === this.formCountry.country.code)) {
        this.$set(this.formCountry, 'country', this.countries.find(item => item.code === 'CL'))
      }
      this.checkAvailability()
    },
    checkAvailability () {
      if (!this.formCountry?.country?.code) return
      const countryCode = this.formCountry.country.code
      const allowedTabs = this.allowedTabsByCountry[countryCode] || []
      // Usar Vue.set para asegurar reactividad
      Object.keys(this.allow).forEach(key => {
        this.$set(this.allow, key, allowedTabs.includes(key))
      })
    },
    handleClickOnComponent (event, click) {
      if (click) return
      event.preventDefault()
    },
    setSelectOptions (name, { options }) {
      const index = this.fieldsCountry.findIndex(el => el.name === name)
      if (index !== -1) {
        this.fieldsCountry[index].options = options
        this.keyFormRenderCountry++
      }
    },
    activatedEvent(newT, prevT, bvEvent) {
      const key = this.TAB_KEYS[newT]
      if (this.callingService || !this.allow[key]) bvEvent.preventDefault()
    },
    close(bvModal) {
      if (this.callingService) bvModal.preventDefault()
    },
    closeModal () {
      this.$bvModal.hide('modal-upload-files')
    },
    blockTabs(bool) {
      /*******
      * Para bloquear algunos funcionamientos por defecto como:
      * 1- No permitir la activacion de las tabs
      * 2- No permitir cerrar el modal
      ********/
      this.callingService = bool
    },
    showDetailsOfInfo() {
      this.showDetails = true
    },
    detailsGoBack() {
      this.showDetails = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .modal-upload-files{
    .card {
      min-height: 500px;
      background-color: red !important;
    }
  }
</style>
